import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Grid,
  Avatar,
  IconButton,
} from "@mui/material";
import { AccessTime, DoNotTouchRounded, Person } from "@mui/icons-material";
import LatestNewsImage from "../../../../../Assets/latestNewsImage.jpg";
import { FaRegUser } from "react-icons/fa";
import { GoDotFill } from "react-icons/go";
import { date } from "yup";
import { useDispatch, useSelector } from "react-redux";
import { adminUrl } from "../../../../../constants";
import actions from "../../../../../ReduxStore/actions";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";

const NextStepForwardGold = ({ nextStepDates, handleReadMoreOpenModal, values,onClose,sectionNameForApproveAndReject }) => {


  const [responseData, setResponseData] = useState()

  console.log(values, "valuesssss")
  console.log(responseData, "responseDatattaatatatt")
  const TableId = useSelector((state) => state.Table.TableId);

  console.log(TableId, "TebleIddddd")

  const dispatch = useDispatch()

  useEffect(() => {
    console.log(TableId, "TebleIddddd111")

    if (TableId && !values) {
      console.log(TableId, "TebleIddddd222")

      const fetchData = async () => {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getBlogSectionById/${TableId}`,
        };
        const response = await dispatch(actions.GETBLOGSECTIONBYID(data1));

        console.log(response, "responseresponse")

        if (response?.payload?.message === "Blog section retrieved successfully.") {
          console.log("hiiii")

          setResponseData(response?.payload?.data)
          // setUploadedFile({
          //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
          //     type: "img",
          //     progress: 100,
          // }
          // )
          // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
        }
      };
      fetchData();
    }

  }, []);

  const data1 = nextStepDates?.[0]?.additional_data?.card_design || [
    {
      title: "Jenny Watson",
      date: "24 Jan 2024",
      secondary_title: "Expert Insights at Your Fingertips",
      content:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500... Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500...Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500... Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500...",
    },
    {
      title: "Jenny Watson",
      date: "25 Jan 2024",
      secondary_title: "Discover the Golden Opportunity",
      content:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500...",
    },
    {
      title: "Jenny Watson",
      date: "26 Jan 2024",
      secondary_title: "Your Gateway to Success",
      content:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500...",
    },
    {
      title: "Jenny Watson",
      date: "27 Jan 2024",
      secondary_title: "Take the Next Step",
      content:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500...",
    },
    {
      title: "Jenny Watson",
      date: "28 Jan 2024",
      secondary_title: "Embrace the Future of Gold",
      content:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500...",
    },
  ];



  const data = values ? values?.cards?.map((data) => ({
    logo: data?.image?.fileUrl,
    date: data?.card_date,
    title: data?.card_title,
    secondary_title: data?.cart_title_secondtext,
    textContent: data?.card_content
  })) : (responseData?.additional_data?.card_design?.map((data) => ({
    logo: data?.logo,
    title: data?.title,
    secondary_title: data?.cart_title_secondtext,
    date: data?.card_date,

    textContent: data?.content
  })))

  console.log(data, "datatata")

  const [modalData, setModalData] = useState();
  useEffect(() => {
    setModalData({
      date: nextStepDates?.[0]?.additional_data?.card_design[0].date,
      title: nextStepDates?.[0]?.additional_data?.card_design[0].title,
      secondary_title:
        nextStepDates?.[0]?.additional_data?.card_design[0].secondary_title,
      image: nextStepDates?.[0]?.additional_data?.card_design[0].banner,
      textContent: nextStepDates?.[0]?.additional_data?.card_design[0].content,
    });
  }, []);
  return (
    <>
      <Box sx={{ background: "white" }}>
        <Box
          sx={{
            textAlign: "center",
            mb: 4,
            display: "flex",
            justifyContent: "center",
          }}
        >
          {/* Header Section */}
          <Box>
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                paddingBottom: "5px",
                //  fontSize: "30px",
                // fontSize: { xs: 24, md: 32 },

                maxWidth: "600px",
              }}
            >
              {responseData?.heading || values?.heading_title ||
                "Your Next Step Towards Gold Purchase"}
              <span style={{ color: "black", fontWeight: "800" }}>
                {" "}
                {responseData?.sub_heading || values?.heading_second_text || "Success Starts Here!"}
              </span>
            </Typography>
          </Box>
        </Box>
        {/* Main Content */}
        <Grid container spacing={3}>
          {/* Left Highlighted Card */}
          <Grid item xs={12} md={5} sx={{ maxHeight: "700px" }}>
            <Card
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                background: "none",
                boxShadow: "none",
              }}
            >
              <CardMedia
                component="img"
                // image={LatestNewsImage} // Replace with actual image
                sx={{ height: "250px", width: "300px", borderRadius: "10px" }}
                image={`${adminUrl}${responseData?.additional_data?.card_design[0].logo || values?.cards[0]?.image?.fileUrl}`} // Replace with actual image
                alt="Main Image"
              />
              <CardContent sx={{ p: "16px 0px" }}>
                <Box display="flex" alignItems="center" gap={2} mb={1}>
                  <Typography
                    variant="body1"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#C38F51",
                    }}
                  >
                    <FaRegUser style={{ marginRight: "5px" }} />{" "}
                    {responseData?.additional_data?.card_design[0].title || values?.cards[0]?.card_title ||
                      "Jenny Watson"}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#C38F51",
                    }}
                  >
                    <GoDotFill fontSize="small" style={{ marginRight: "5px" }} />{" "}
                    {responseData?.additional_data?.card_design[0].card_date || values?.cards[0]?.card_date ||

                      // {nextStepDates?.[0]?.additional_data?.card_design[0].date ||
                      "24 Jan 2024"}
                  </Typography>
                </Box>
                <Typography variant="h6">
                  {responseData?.additional_data?.card_design[0]
                    .secondary_title || values?.cards[0]?.cart_title_secondtext || "Expert Insights at Your Fingertips"}


                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ textAlign: "justify" }}>
                  <Box
                    sx={{
                      lineHeight: "1.5",
                      overflow: "hidden",
                      maxHeight: {
                        // xs: "150px", sm: "100px",
                        md: "290px"
                      },
                    }}
                  >
                    {(() => {
                      const content = responseData?.additional_data?.card_design[0].content || values?.cards[0]?.card_content || "";
                      const words = content.split(" ");
                      return words.slice(0, 50).join(" ") + (words.length > 50 ? "..." : "");
                    })()}
                  </Box>

                  {((responseData?.additional_data?.card_design[0].content || values?.cards[0]?.card_content || "").split(" ").length > 50) && (
                    <span
                      style={{ color: "#C38F51", cursor: "pointer" }}
                    // onClick={() => handleReadMoreOpenModal(modalData)}
                    >
                      Read more
                    </span>
                  )}
                </Typography>

              </CardContent>
            </Card>
          </Grid>

          {/* Right Smaller Cards */}
          <Grid item xs={12} md={7}>
            <Grid container spacing={2}>
              {data?.slice(1).map((item, index) => (
                <Grid item xs={12} key={index}>
                  <Card
                    sx={{
                      display: "flex",
                      p: 0,
                      // height: "170px",
                      boxShadow: "none",
                      background: "none",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{
                        width: "150px", height: "150px",
                        borderRadius: "10px"
                      }}
                      image={`${adminUrl}${item?.logo}`} // Replace with actual image
                      // image={LatestNewsImage} // Replace with actual image
                      alt="Small Card Image"
                    />
                    <CardContent
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between", // Ensures the content is spaced evenly
                        alignItems: "flex-start", // Align content to the left
                        // height: "170px",
                        p: "0px 0px 0 8px",
                        paddingBottom: 0, // Remove unnecessary padding
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          // height: "170px",
                        }}
                      >
                        <Box
                          sx={{
                            gap: { xs: 0, md: 2 },
                            display: "flex",
                            justifyContent: { xs: "start", md: "space-between" },
                            flexDirection: { xs: "column", md: "row" }, // Flex direction: column for mobile, row for desktop
                            alignItems: { xs: "start", md: "center" }, // Align items: end for mobile, center for desktop
                          }}
                          mb={1}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#C38F51",
                              // fontSize: { xs: "10px", md: "14px" },
                            }}
                          >
                            <FaRegUser style={{ marginRight: "5px" }} />
                            {item?.secondary_title}
                          </Typography>
                          <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#C38F51",
                            }}
                          >
                            <GoDotFill style={{ marginRight: "5px" }} />
                            {item?.date}
                          </Typography>
                        </Box>

                        <Typography
                          variant="body2"
                          sx={{
                            // fontSize: { xs: "12px", md: "16px" },
                            // fontWeight: { xs: "400", md: "700" },
                            mb: 1,
                          }}
                        >
                          {item.title}
                        </Typography>
                        {/* <Typography variant="body1" color="text.secondary">
                        <Box
                          sx={{
                            textAlign: "justify",

                            overflow: "hidden",
                            maxHeight: { xs: "70px", md: "65px" },
                          }}
                        >
                          {item.content}
                        </Box>
                        <span
                         
                          variant="text"
                          style={{ color: "#C38F51", cursor: "pointer" }}
                        >
                          Read more
                        </span>
                      </Typography> */}
                        <Typography variant="body1" color="text.secondary">
                          <Box
                            sx={{
                              textAlign: "justify",
                              overflow: "hidden",
                              // maxHeight: { xs: "70px", md: "65px" },
                            }}
                          >
                            {(item?.textContent || "").split(" ").slice(0, 20).join(" ")}
                            {(item?.textContent || "").split(" ").length > 20 && (
                              <>
                                <span>...</span>
                                <span onClick={() => {
                                  handleReadMoreOpenModal({
                                    date: item.card_date,
                                    title: item.cart_title_secondtext,
                                    secondary_title: item.title,
                                    image: item.logo,
                                    textContent: item.content,
                                  })
                                }} variant="text" style={{ color: "#C38F51", cursor: "pointer" }}>
                                  Read more
                                </span>
                              </>
                            )}
                          </Box>

                        </Typography>


                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject} />
    </>
  );
};

export default NextStepForwardGold;
